"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrataTable = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const Colors_1 = require("../../../../../Colors");
const common_1 = require("../../../../../common");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const server_1 = require("../../../../../server");
const ErrataTableStyled = styled_components_1.default.div `
	flex: 1;

	.popup-list-005 {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
	}

	.item {
		display: flex;
		flex-shrink: 0;
		position: relative;

		.body-item {
			color: var(--color-black, #101010);
			text-align: center;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			line-height: var(--b4-line-height, 28px);
			font-weight: var(--b4-font-weight, 400);
			position: relative;
			align-items: center;
			display: flex;
		}
	}

	.answer {
		display: flex;
		flex-direction: column;
		gap: 10px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;

		.frame {
			border-color: var(--color-black, #101010);
			border-radius: 50px;
			width: 28px;
			height: 28px;
			border-style: solid;
			border-width: 1px;
			padding: 0px 10px 0px 10px;
			display: flex;
			flex-direction: row;
			gap: 10px;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--color-black, #101010);
				text-align: center;
				font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b4-font-size, 14px);
				line-height: var(--b4-line-height, 28px);
				font-weight: var(--b4-font-weight, 400);
				position: relative;
			}
		}

		/* 정답: 기존 표기 유지 — 핑크 테두리 + 핑크 숫자(내부를 채우지 않는다). */
		&.pink {
			.frame {
				border-color: var(--color-pink, #f46790);
			}

			p {
				color: var(--color-pink, #f46790);
			}
		}

		/* 제출(선택) 답안: 응시 화면의 선택 표시와 동일하게 핑크로 원 내부를 채운다(Solid Fill).
		   정답(테두리만)과는 '채움 여부'로 구분된다. 테두리 색을 배경과 같게 맞춰 원 크기 변화 없음. */
		&.submitted {
			.frame {
				background: var(--color-pink, #f46790);
				border-color: var(--color-pink, #f46790);
			}

			p {
				color: var(--color-white, #ffffff);
			}
		}
	}

	.input-answer {
		background: #ffffff;
		border-radius: 4px;
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px;
		padding: 4px 10px 4px 10px;
		white-space: break-spaces;
		width: 100%;
		overflow: hidden;

		/* 주관식 박스 글자색은 정답(.pink)·제출답안(.submitted) 구분 없이 검정으로 통일한다(요청).
		   .pink/.submitted 는 객관식 원 표기(.answer)와 공유되는 클래스라 마크업에는 그대로 남는다. */
		&.pink {
			.value {
				color: var(--color-black, #101010);
			}
		}

		/* 주관식 제출(선택) 답안: 입력칸 형태라 채우지 않는다. 테두리도 강조하지 않고
		   정답 컬럼과 동일한 회색으로 맞춘다(요청). 글자색은 기본(.value = 검정) 유지.
		   → 값 자체는 base .input-answer 와 같지만, 표기 기준을 명시해 두기 위해 규칙을 남긴다.
		   (객관식 제출답안 원만 분홍 채움 / 주관식 정답은 &.pink = 분홍 글자) */
		&.submitted {
			border-color: var(--color-grey-w, #b6bac0);
		}

		.value {
			overflow-wrap: break-word;
			color: var(--color-black, #101010);
			text-align: left;
			font-family: var(--b4-font-family, 'NotoSansKr-Regular', sans-serif);
			font-size: var(--b4-font-size, 14px);
			line-height: var(--b4-line-height, 22px);
			letter-spacing: var(--b4-letter-spacing, -0.02em);
			font-weight: var(--b4-font-weight, 400);
			position: relative;
			align-self: stretch;
			flex: 1;
		}
	}

	.input_answer_wrapper {
		background: #ffffff;
		border-radius: 4px;
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px;
		display: flex;
		flex-direction: row;
		gap: 6px;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		position: relative;
		width: 100%;
		overflow: hidden;

		input {
			width: 100%;
			outline: none;
			border: none;
			background: none;
		}
	}

	${props => (props.$isMobile ? mobileStyles : desktopStyles)}

	/* 태블릿(가로) 과제/테스트 상세 > 문항별 상세: 선택 행 정렬 보정.
	   selectedId/item.id가 모두 undefined라 모든 행에 .selected가 붙고,
	   desktopStyles의 .item이 flex-start로 정렬되어 행 내용이 위로 치우침 → center로 보정.
	   $isTablet 가드로 데스크탑/모바일·강사 데스크탑 뷰에는 영향 없음. */
	${props => props.$isTablet &&
    (0, styled_components_1.css) `
			.item.selected {
				align-items: center;
			}
		`}
`;
const mobileStyles = (0, styled_components_1.css) `
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	height: 100%;
	width: 100%;

	.popup-list-005 {
		align-self: stretch;

		.body-item {
			width: 100%;
			justify-content: flex-start;
		}

		.answer-wrap-mobile {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: ${props => (props.$isTeacher ? 'unset' : 'space-between')};
			align-self: stretch;
			flex-shrink: 0;
			position: relative;
			width: 100%;
		}

		.frame-987021 {
			display: flex;
			flex-direction: row;
			gap: 6px;
			align-self: stretch;

			${props => props.$isTeacher &&
    (0, styled_components_1.css) `
					flex: 1;
					align-items: center;
				`}
			position: relative;
		}

		${props => props.$isTeacher
    ? (0, styled_components_1.css) `
						.body-item {
							gap: 6px;
							width: 100%;
							justify-content: flex-start !important;

							.answer {
								flex: 1;
								align-items: flex-start;
							}
						}

						.answer-wrap {
							flex: 1;
							display: flex;
							flex-direction: row;
							gap: 12px;
						}

						.answer-wrap-mobile {
							gap: 12px;
							width: 100%;
						}
				  `
    : (0, styled_components_1.css) `
						.answer-wrap-mobile {
							gap: 12px;
						}

						.frame-987021 {
							width: 50%;
							align-items: center;
						}
				  `}
	}

	.item {
		border-style: solid;
		border-color: var(--color-silver, #f3f4f8);
		border-width: 0px 0px 1px 0px;
		padding: 12px 0px 12px 0px;
		flex-direction: column;
		gap: 6px;
		align-items: flex-start;
		justify-content: center;
		align-self: stretch;

		.body-item {
			font-size: var(--b4-font-size, 12px);
		}
	}

	.input_answer_box {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		width: 100%;
	}

	.input_answer_wrapper {
		padding: 10px;
		flex: 1;
		max-height: 38px;
	}

	.answer-text {
		color: var(--color-grey-l, #83868a);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 12px;
		line-height: 150%;
		letter-spacing: -0.02em;
		font-weight: 400;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		flex-shrink: 0;
	}

	.moblie-subject-text {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 14px;
		line-height: 150%;
		letter-spacing: -0.02em;
		position: relative;
		align-self: stretch;
		height: 21px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	.subject-text {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 14px;
		line-height: 150%;
		letter-spacing: -0.02em;
		font-weight: 700;
		position: relative;
		align-self: stretch;
		height: 21px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	.subject-wrapper {
		display: flex;
		flex-direction: row;
		gap: 6px;
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	height: ${props => (props.$noSubmit ? '100%' : 'unset')};
	width: 100%;
	/* overflow: hidden; */

	.popup-list-005 {
		flex: 1;
	}

	.table-header {
		background: var(--color-silver, #f3f4f8);
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px 0px 0px 0px;
		padding: 10px 16px 10px 16px;
		display: flex;
		flex-direction: row;
		gap: 20px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		width: 100%;

		color: var(--color-black, #101010);
		text-align: center;
		font-family: var(--b5-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b5-font-size, 14px);
		line-height: var(--b5-line-height, 22px);
		font-weight: var(--b5-font-weight, 400);
		position: relative;
	}

	.item {
		padding: 8px 16px 8px 16px;
		flex-direction: row;
		gap: 20px;
		align-items: flex-start;
		justify-content: flex-start;
		width: 100%;

		.body-item {
			font-size: var(--b4-font-size, 14px);
			font-size: var(--b4-font-size, 14px);
			line-height: var(--b4-line-height, 28px);
			font-weight: var(--b4-font-weight, 400);
			position: relative;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;

			&.pink {
				color: var(--color-pink, #f46790);
				font-size: var(--b4-font-size, 14px);
				line-height: var(--b4-line-height, 28px);
				font-weight: var(--b4-font-weight, 400);
				position: relative;
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
			}
		}
	}

	.body-item {
		justify-content: center;
	}

	.input_answer_wrapper {
		padding: 4px 10px 4px 10px;
	}
`;
const count = 100;
exports.ErrataTable = react_1.default.memo(({ subject_id, subject_name, isDetail, test_id, member_id, isTeacher = false, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isDesktop, isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const [page, setPage] = (0, react_1.useState)(0);
    const [testData, setTestData] = (0, react_1.useState)();
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const [notSubmit, setNotSubmit] = (0, react_1.useState)(false);
    const { data: statisticData, refetch: statisticRefetch } = (0, server_1.useStatistics)({ test_id });
    //모바일 창에서 오답률을 보여주기 위해
    (0, react_1.useEffect)(() => {
        statisticRefetch();
    }, [test_id]);
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        // 기본적인 항목들
        const headTitleList = [
            { title: 'subject', space: 2, sort: false },
            { title: 'no', space: 1, sort: false },
            { title: 'answer', space: 1, sort: false },
            ...(isDetail ? [{ title: 'submitAnswer', space: 1, sort: false }] : []),
            ...(isDetail && !notSubmit ? [{ title: 'errata', space: 1, sort: false }] : []),
            { title: 'score', space: 1, sort: false },
        ];
        const tableReadDataKeys = [
            { title: 'subject', space: 2 },
            { title: 'number', space: 1 },
            { title: 'answer', space: 1 },
            ...(isDetail ? [{ title: 'value', space: 1 }] : []),
            ...(isDetail && !notSubmit ? [{ title: 'correction', space: 1 }] : []),
            { title: 'point', space: 1 },
        ];
        // useMemo에서 반환
        return { headTitleList, tableReadDataKeys };
    }, [notSubmit]);
    const { data, refetch } = (0, server_1.useScoreStatus)({
        id: test_id,
        member_id,
        offset: page === 0 ? 0 : page * count,
        limit: count,
        valid_correction: member_id === '' ? false : true,
        subject_item: subject_id,
    });
    const refetchList = (0, throttle_1.default)(refetch, 1000, { leading: true, trailing: false });
    (0, react_1.useEffect)(() => {
        if (test_id)
            refetchList();
    }, [member_id, test_id, subject_id]);
    (0, react_1.useEffect)(() => {
        if (data && data.length > 0) {
            setTestData(data);
            setNotSubmit(member_id && data.every(i => i.correction === '' && i.value === ''));
            setTotalCount(data.length);
            return;
        }
        setTestData([]);
        setTotalCount(0);
        setNotSubmit(true);
    }, [data]);
    const handlerMoreData = () => {
        setPage(prevPage => prevPage + 1);
    };
    const renderBodyItem = (item, headItem, styles, isMobile, subject_name) => {
        const getContent = () => {
            if (isMobile && ['point', 'number'].includes(headItem.title))
                return null;
            switch (headItem.title) {
                case 'correction':
                    return react_1.default.createElement(common_1.Icon, { icon: item[headItem.title] === 'O' ? 'pass' : 'fail' });
                case 'value':
                case 'answer':
                case 'submitAnswer':
                    return (react_1.default.createElement(react_1.default.Fragment, null, !item[headItem.title] ? ('-') : item.type === 'choice' ? (isMobile ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: "answer-wrap" },
                            react_1.default.createElement("div", { className: "answer-text" }, t('assignment.answer')),
                            react_1.default.createElement("div", { key: 'choiceAnswer', className: `answer ${headItem.title === 'answer' ? 'pink' : 'submitted'}`, style: styles?.bodyText },
                                react_1.default.createElement("div", { className: "frame" },
                                    react_1.default.createElement("p", null, item[headItem.title] || '-')))),
                        react_1.default.createElement("div", { className: "input_answer_wrapper" },
                            react_1.default.createElement(common_1.InputElement, { type: "text", isDisable: true, defaultValue: item[isMobile ? 'point' : headItem.title] }),
                            "\uC810"))) : (react_1.default.createElement("div", { className: `answer ${headItem.title === 'answer' ? 'pink' : 'submitted'}`, style: styles?.bodyText },
                        react_1.default.createElement("div", { className: "frame" },
                            react_1.default.createElement("p", null, item[headItem.title] || '-'))))) : isMobile ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: "answer-wrap" },
                            react_1.default.createElement("div", { className: "answer-text" },
                                t('assignment.answer'),
                                ' '),
                            react_1.default.createElement("div", { className: `input-answer ${headItem.title === 'answer' ? 'pink' : ''}` },
                                react_1.default.createElement("p", { className: "value" },
                                    item.answer,
                                    " "))),
                        react_1.default.createElement("div", { key: 'AnswerWrap', className: "input_answer_wrapper" },
                            react_1.default.createElement(common_1.InputElement, { type: "text", isDisable: true, defaultValue: item[isMobile ? 'point' : headItem.title] }),
                            "\uC810"))) : (react_1.default.createElement("div", { className: `input-answer ${headItem.title === 'answer' ? 'pink' : 'submitted'}` },
                        react_1.default.createElement("p", { className: "value" }, item[isMobile ? 'point' : headItem.title])))));
                case 'point':
                    return (react_1.default.createElement("div", { className: "input_answer_wrapper" },
                        react_1.default.createElement(common_1.InputElement, { type: "text", isDisable: true, defaultValue: item[isMobile ? 'point' : headItem.title] }),
                        "\uC810"));
                case 'subject':
                    return (react_1.default.createElement("div", { key: headItem.title, className: isTeacher ? 'subject-wrapper' : '' },
                        isMobile && isTeacher && (react_1.default.createElement("p", { className: "subject-text" }, item['number'])),
                        react_1.default.createElement("div", { className: isMobile ? 'moblie-subject-text' : 'subject-text' }, ['history', 'character'].includes(subject_name)
                            ? t(`assignment.${subject_name}`)
                            : item[headItem.title])));
                default:
                    return react_1.default.createElement("p", { className: "overText" }, item[headItem.title]);
            }
        };
        return (react_1.default.createElement("div", { key: headItem.title, className: "body-item", style: {
                flex: !isMobile && headItem.space,
                ...styles?.bodyItem,
                overflow: 'hidden',
            } }, getContent()));
    };
    const renderItem = (item, styles) => tableReadDataKeys.map(headItem => renderBodyItem(item, headItem, styles, isMobile, subject_name));
    //학생 모바일 UI / 강사 모바일 자세히보기 UI
    const renderMobileItem = (item, styles) => {
        const { number, answer, value } = item;
        return tableReadDataKeys.map(headItem => {
            if (['number', 'answer', 'value'].includes(headItem.title))
                return null;
            if (headItem.title === 'correction') {
                return (react_1.default.createElement("div", { key: headItem.title, className: "body-item", style: {
                        flex: !isMobile && headItem.space,
                        ...styles?.bodyItem,
                        overflow: 'hidden',
                        flexDirection: 'column',
                    } }, isTeacher ? (react_1.default.createElement("div", { className: "answer-wrap-mobile" },
                    react_1.default.createElement("div", { className: "frame-987021" },
                        react_1.default.createElement("div", { className: "answer-text" }, t('assignment.answer')),
                        item.type === 'choice' ? (react_1.default.createElement("div", { className: "answer pink", style: styles?.bodyText },
                            react_1.default.createElement("div", { className: "frame" },
                                react_1.default.createElement("p", null, answer)))) : (react_1.default.createElement("div", { className: "input-answer" },
                            react_1.default.createElement("p", { className: "value" },
                                item.answer,
                                " ")))),
                    react_1.default.createElement("div", { className: "frame-987021" },
                        react_1.default.createElement("div", { className: "answer-text" }, t('assignment.submitValue')),
                        item.type === 'choice' ? (react_1.default.createElement("div", { className: "answer submitted", style: styles?.bodyText },
                            react_1.default.createElement("div", { className: "frame" },
                                react_1.default.createElement("p", null, value)))) : (react_1.default.createElement("div", { className: "input-answer submitted" },
                            react_1.default.createElement("p", { className: "value" },
                                item.value,
                                " ")))))) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "answer-wrap-mobile" },
                        react_1.default.createElement("div", { className: "frame-987021" },
                            react_1.default.createElement("div", { className: "answer-text" }, t('assignment.no')),
                            react_1.default.createElement("p", null, number)),
                        react_1.default.createElement("div", { className: "frame-987021" },
                            react_1.default.createElement("div", { className: "answer-text" }, t('assignment.errata')),
                            react_1.default.createElement(common_1.Icon, { icon: item[headItem.title] === 'O' ? 'pass' : 'fail' }))),
                    react_1.default.createElement("div", { className: "answer-wrap-mobile", style: {
                            flexDirection: item.type === 'choice' ? 'row' : 'column',
                        } },
                        react_1.default.createElement("div", { className: "frame-987021", style: {
                                width: item.type === 'choice' ? '50%' : '100%',
                            } },
                            react_1.default.createElement("div", { className: "answer-text", style: { minWidth: 55 } }, t('assignment.answer')),
                            item.type === 'choice' ? (react_1.default.createElement("div", { className: "answer pink", style: styles?.bodyText },
                                react_1.default.createElement("div", { className: "frame" },
                                    react_1.default.createElement("p", null, answer)))) : (react_1.default.createElement("div", { className: "input-answer" },
                                react_1.default.createElement("p", { className: "value" },
                                    item.answer,
                                    " ")))),
                        react_1.default.createElement("div", { className: "frame-987021", style: {
                                width: item.type === 'choice' ? '50%' : '100%',
                            } },
                            react_1.default.createElement("div", { className: "answer-text", style: { minWidth: 55 } }, t('assignment.submitValue')),
                            item.type === 'choice' ? (react_1.default.createElement("div", { className: "answer submitted", style: styles?.bodyText },
                                react_1.default.createElement("div", { className: "frame" },
                                    react_1.default.createElement("p", null, value)))) : (react_1.default.createElement("div", { className: "input-answer submitted" },
                                react_1.default.createElement("p", { className: "value" },
                                    item.value,
                                    " ")))))))));
            }
            else if (headItem.title === 'point') {
                return (react_1.default.createElement("div", { key: headItem.title, className: "input_answer_box" },
                    isTeacher && (react_1.default.createElement("div", { className: "frame-987021" },
                        react_1.default.createElement("div", { className: "answer-text" }, t('assignment.errata')),
                        react_1.default.createElement(common_1.Icon, { icon: item[headItem.title] === 'O' ? 'pass' : 'fail' }))),
                    react_1.default.createElement("div", { className: "input_answer_wrapper" },
                        react_1.default.createElement(common_1.InputElement, { type: "text", isDisable: true, defaultValue: item[headItem.title] }),
                        "\uC810"),
                    !isTeacher && (react_1.default.createElement("div", { className: "input_answer_wrapper" },
                        react_1.default.createElement(common_1.InputElement, { type: "text", isDisable: true, defaultValue: (statisticData.hardest_rank.find(rate => rate.question_id === item.question_id)?.incorrect_rate || '0') + '%' })))));
            }
            return renderBodyItem(item, headItem, styles, true, subject_name);
        });
    };
    const renderEmpty = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement("div", { className: "flex center body3 sel_eval_item", style: { color: Colors_1.Colors.light_grey, width: '100%', height: '100%' } }, t('assignment.noSubmitPersonGuid')));
    }, []);
    return (react_1.default.createElement(ErrataTableStyled, { className: "errata_table", "$isDesktop": isDesktop, "$isTablet": isTablet, "$isMobile": isMobile, "$isTeacher": isTeacher, "$noSubmit": notSubmit, style: {
            padding: isTablet ? '0 0 20px' : '0',
        } },
        react_1.default.createElement(common_1.Table, { className: "popup-list-005", showIndex: false, isInfinite: true, page: page, data: testData, showCount: count, renderEmpty: member_id === '' ? undefined : notSubmit && renderEmpty, totalCount: totalCount, headTitleList: headTitleList, styles: {
                headWrapper: {
                    justifyContent: 'center',
                    alignItems: 'center',
                },
                headItem: {
                    alignItems: 'center',
                    justifyContent: 'center',
                },
            }, renderItem: isMobile && ((isTeacher && isDetail) || !isTeacher)
                ? renderMobileItem
                : renderItem, handlerMoreData: handlerMoreData, forceShowheader: isMobile ? false : true, padding: false })));
});
